import { useEffect } from 'react';
import { addLinkUrl, addManifest } from '../../../components/InstallApp/manifest';
import useStore from '../../../hooks/useStore';
import { getCompteParticulier, setCompte } from '../../../redux/AdherentRedux';
import { getPersonnalisationPart, setPersonnalisationPart } from '../../../redux/ReferentielRedux';
import { CompteParticulier, PersonnalisationClient } from '../../../services/Api/swagger';
import { getUsername } from '../../../services/Authentification/authentification';
import { getCDNUrl } from '../../../services/Config';

export const useCompte = () => {
  const login = getUsername();

  const { liste: infoCompte, fetching: fetchingCompte, error: errorCompte } = useStore<CompteParticulier>(
    login,
    'getCompte',
    setCompte,
    getCompteParticulier,
    login ? true : false,
  );

  // store la Personnalisation de l'utilisateur quand loggué
  const {
    liste: personnalisation,
    fetching: fetchingPersonnalistion,
    error: errorPersonnalisation,
  } = useStore<PersonnalisationClient>(
    login,
    'getPersonnalisationPart',
    setPersonnalisationPart,
    getPersonnalisationPart,
    login !== undefined ? true : false,
  );

  const cdn_url = getCDNUrl();
  // set le Manifest une fois la personnalisation du client récupérée
  useEffect(() => {
    if (personnalisation) {
      addManifest(personnalisation);
      if (personnalisation.personnalisation) {
        addLinkUrl(personnalisation.personnalisation.id, cdn_url);
      } else {
        addLinkUrl(undefined, cdn_url);
      }
    }
  }, [personnalisation]);

  return { infoCompte, fetchingCompte, errorCompte, personnalisation, fetchingPersonnalistion, errorPersonnalisation };
};
